import { useQuery } from "@tanstack/react-query";
import { getProductBySlug } from "../../api/apiStorefront";
import i18next from "i18next";

/**
 * Hook to fetch single product details by slug
 * @param {string} slug - Product slug
 */
export function useGetProductBySlug(slug) {
    const {
        isLoading,
        data,
        error,
        refetch,
    } = useQuery({
        queryKey: ["product", i18next.language, slug],
        queryFn: () => getProductBySlug(slug),
        retry: false,
        enabled: !!slug,
    });

    const product = data?.data?.data || null;

    return { isLoading, error, product, refetch };
}
